import _ from 'lodash'

export default {
  showTitle: (p) => {
    return p.title
  },
  showPrice: (s, v, p) => {
    return v.currency.showPrice(s, v, {
      price: p.price,
      original: p.compare_at_price,
    })
  },
  showNote: (p) => {
    let message = false

    // Calculate total inventory across all variants with inventory tracking
    const total_inventory = _.sumBy(p.variants, (v) => {
      if (
        v.inventory_management == 'shopify' &&
        v.inventory_policy == 'deny' &&
        v.inventory_quantity != null &&
        v.inventory_quantity > 0
      ) {
        return v.inventory_quantity
      }
      return 0
    })

    // Only show "Low in Stock" if total inventory is less than 3
    const is_low = total_inventory > 0 && total_inventory < 3

    if (p.compare_at_price > p.price) message = 'On Sale'
    if (is_low) message = 'Low in Stock'
    if (!p.available) message = 'Sold Out'

    return message ? message : ''
  },
  showMood: (state, view, product) => {
    // Handle cases where product might not have images (e.g., search results)
    let image_path = ''
    
    if (product.images && product.images.length > 0) {
      image_path = product.images.length > 1 ? product.images[1].src : product.images[0].src
    } else if (product.featured_image) {
      // Fallback to featured_image if images array is empty
      image_path = product.featured_image
    } else {
      // Return empty style if no images available
      return {}
    }

    image_path = view.app.showImage(image_path, view.products.getResize())

    return { 'background-image': `url(${image_path}` }
  },
  getResize: () => {
    return '600x800_crop_center'
  },
  formatProducts: (d) => {
    const products = _.chunk(d.products, 2)
    return products
  },
  showAvailability: (p) => {
    if (p.tags && p.tags.some((t) => t.toLowerCase() === 'denim')) return ''

    const colours = _.filter(p.variants, (v) => {
      return v.available
    })

    const pluralise = colours && colours.length > 1 ? 'colors' : 'color'

    return colours && colours.length > 1 ? `Available in ${colours.length} ${pluralise}` : ''
  },
}
